import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PayrollDeductionsMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { NotifyService } from '@app/services';
import { CompanyDeduction } from '@models/payroll/company/deduction.model';
import { DeductionType } from '@models/payroll/deduction-type.model';

@Component({
    templateUrl: './deduction-show.template.html',
})
export class DeductionShowView {
    isLoading = true;
    deduction: CompanyDeduction;
    deductionType?: DeductionType;

    constructor(
        private notify: NotifyService,
        public route: ActivatedRoute,
        private router: Router,
        public payrollDeductionsMenuService: PayrollDeductionsMenuService
    ) {
        this.deduction = this.route.snapshot.data.models.get('deduction');

        this.loadDeductionType(this.deduction.deductionType?.id);
    }

    async onDelete(): Promise<void> {
        try {
            this.isLoading = true;

            await this.deduction.delete();

            this.notify.success('success');
            this.router.navigate(['/payroll/deductions']);
        } catch (err) {
            this.isLoading = false;
            this.notify.error(err);
        }
    }

    onEdit(): void {
        this.router.navigate(['edit'], { relativeTo: this.route });
    }

    /**
     * Load the full deduction type model.
     */
    private async loadDeductionType(deductionTypeId?: number): Promise<void> {
        if (deductionTypeId) {
            this.deductionType = await DeductionType.with(['t4_boxes', 'rl1_boxes']).find(deductionTypeId);
        }
        this.isLoading = false;
    }
}
